export default {
  options: {
    none: 'Ei aloituskampanjakoodia',
  },
  buttons: {
    next: 'Seuraava',
    back: 'Takaisin',
    skip: 'Ohita',
  },
};
